import { Dispatch } from 'application/redux'
import authService from 'core/auth'
import { add, remove } from "core/spinner/redux/actions"
import { addToaster } from "core/toaster/redux/actions"
import { ToasterType } from 'core/toaster/redux/types'
import fetchCurrentDVBCData from "./services"
import { DVBCHistory, DVBC_FETCH, DVBC_HISTORY_SUCCESS } from "./types"

function fetchSuccess(payload: Array<DVBCHistory>) {
  return {
    type: DVBC_HISTORY_SUCCESS,
    payload
  }
}

export function fetchHistory(deviceId: string) {
  return async (dispatch: Dispatch) => {
    dispatch(add(DVBC_FETCH, {}))
    await authService.refreshToken()
    try {
      const { data } = await fetchCurrentDVBCData(deviceId)

      dispatch(fetchSuccess(data))
    } catch (e) {
      dispatch(
        addToaster({
          title: 'rf_tuning.tab_dvbc_monitoring',
          message: 'error_messages.VIPOC_ERROR_067',
          type: ToasterType.danger
        })
      )
    } finally {
      dispatch(remove(DVBC_FETCH))
    }
  }
}
